import { useRef, useState } from 'react';
import axios from 'axios';
import { addSuppressionLabelsOverlay } from './ColumnChartFiltered';

export default function ChartFilters({
  filterConfig,
  filterOptions,
  baseUri,
  chartId,
  options,
  setOptions,
}) {
  const filterRefs = useRef({});
  const [disabledFilters, setDisabledFilters] = useState([]);

  const fetchChartData = async (updatedChartId, filters) => {
    const endpoint = `${baseUri}/chart/bar/${updatedChartId}?${filters}`;
    console.log('Fetching chart:', endpoint);

    try {
      const response = await axios.get(endpoint);
      const newSeries = response.data.series;
      const newChartType = updatedChartId.includes('line') ? 'line' : 'column';
      console.log('NEW CHART TYPE', newChartType);

      let updatedOptions = {
        ...options,
        chart: { ...options.chart, type: newChartType },
        xAxis: { ...options.xAxis, categories: response.data.categories },
        series: newSeries,
      };

      if (newChartType === 'line' || newChartType === 'column') {
        updatedOptions = addSuppressionLabelsOverlay(
          updatedOptions,
          response.data.categories,
          newSeries
        );
      }

      setOptions(updatedOptions);
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };

  const handleFilterClick = async () => {
    console.log('Current chartId:', chartId);
    let updatedChartId = chartId;
    const newDisabledFilters = [];

    const filters = filterConfig.filters
      .map((filter) => {
        const selectedValue =
          filterRefs.current[filter.key]?.value ?? '-- All --';

        if (selectedValue !== '-- All --' && Array.isArray(filter.ifSelected)) {
          const queryOverride = filter.ifSelected.find(
            (item) =>
              item &&
              typeof item === 'object' &&
              typeof item.query === 'string' &&
              item.query.trim().length > 0
          );
          if (queryOverride) {
            updatedChartId = queryOverride.query;
          }

          filter.ifSelected.forEach((item) => {
            if (item && Array.isArray(item.disable)) {
              newDisabledFilters.push(...item.disable);
            }
          });
        }

        return `${filter.key}=${encodeURIComponent(selectedValue)}`;
      })
      .join('&');

      console.log('FILTERS', filters);

    chartId = updatedChartId;
    setDisabledFilters(newDisabledFilters);
    await fetchChartData(updatedChartId, filters);
  };

  /** ✅ Reset all filters to "-- All --" and reload default chart */
  const handleResetFilters = async () => {
    // Reset all select boxes to "-- All --"
    Object.values(filterRefs.current).forEach((selectEl) => {
      if (selectEl) selectEl.value = '-- All --';
    });

    // Clear disabled filters
    setDisabledFilters([]);

    // Build default query string
    const filters = filterConfig.filters
      .map((filter) => `${filter.key}=${encodeURIComponent('-- All --')}`)
      .join('&');

    await fetchChartData(chartId, filters);
  };

  return (
    <div
      style={{
        marginBottom: '1rem',
        fontFamily:
          '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
        fontSize: '14px',
      }}
    >
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
        {filterConfig.filters.map((filter) => (
          <div key={filter.key}>
            <label
              htmlFor={filter.key}
              style={{
                display: 'block',
                fontWeight: 'bold',
                marginBottom: '0.5rem',
              }}
            >
              {filter.title}
            </label>
            <select
              id={filter.key}
              name={filter.key}
              ref={(el) => (filterRefs.current[filter.key] = el)}
              disabled={disabledFilters.includes(filter.key)}
              defaultValue={(() => {
                const filterData = filterOptions[filter.key];
                // Use default value if provided, otherwise "-- All --"
                return !Array.isArray(filterData) && filterData?.default
                  ? filterData.default
                  : "-- All --";
              })()}
              style={{
                padding: '0.5rem',
                fontFamily:
                  '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
                fontSize: '14px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}
            >
              {(() => {
                const filterData = filterOptions[filter.key];
                // Handle both old array format and new object format with default
                const optionsArray = Array.isArray(filterData)
                  ? filterData
                  : filterData?.values || [];
                
                // Check if "-- All --" should be included based on whether there's a default
                const hasDefault = !Array.isArray(filterData) && filterData?.default;
                
                return (
                  <>
                    {!hasDefault && <option value="-- All --">-- All --</option>}
                    {optionsArray.map((option, index) => (
                      <option
                        key={index}
                        value={option === '-- All --' ? '' : option}
                      >
                        {option}
                      </option>
                    ))}
                  </>
                );
              })()}
            </select>
          </div>
        ))}
      </div>

      {/* Filter and Reset buttons */}
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button
          onClick={handleFilterClick}
          style={{
            padding: '0.5rem 1rem',
            fontFamily:
              '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
            fontSize: '14px',
            color: '#fff',
            backgroundColor: '#007BFF',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Filter
        </button>

        <button
          onClick={handleResetFilters}
          style={{
            padding: '0.5rem 1rem',
            fontFamily:
              '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
            fontSize: '14px',
            color: '#007BFF',
            backgroundColor: '#fff',
            border: '1px solid #007BFF',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
}





